import { AutoplayVideo } from './AutoplayVideo';

type VideoStillProps = {
  src: string;
  className?: string;
  'aria-label'?: string;
};

export function VideoStill({ src, className, 'aria-label': ariaLabel }: VideoStillProps) {
  return (
    <AutoplayVideo
      src={src}
      className={['still-video', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
    />
  );
}
